import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AuthLayout } from '@/components/auth/AuthLayout';
import { LoginForm } from '@/components/auth/LoginForm';
import { redirectIfSignedIn } from '@/lib/use-session';

// `pendingInviteToken` is set when `/invites/$token` bounces a signed-out
// existing-account visitor here. LoginForm reads it and navigates back to
// /invites/$token after a successful sign-in so the invite redeems against
// the freshly-authed session (Case 3 of the email-first chooser flow).
//
// `from` is the legacy "bounce back to this URL after sign-in" param set
// by `_authed.tsx` and a couple of CTAs. No reader honors it yet, but
// existing call sites pass it — accept it here so the validator doesn't
// reject them.
const loginSearchSchema = z.object({
  pendingInviteToken: z.string().min(1).optional(),
  from: z.string().optional(),
});

export const Route = createFileRoute('/auth/login')({
  validateSearch: loginSearchSchema.parse,
  beforeLoad: ({ context }) => redirectIfSignedIn(context),
  component: LoginPage,
});

function LoginPage() {
  const { pendingInviteToken } = Route.useSearch();
  return (
    <AuthLayout headline="Welcome back.">
      <LoginForm
        {...(pendingInviteToken !== undefined ? { pendingInviteToken } : {})}
      />
    </AuthLayout>
  );
}
